// Traduções para o JavaScript do cliente.
//
// O servidor não renderiza estas telas: a ilha do Spreads, a toolbar, os modais
// de formatação e o assistente de fórmulas montam o próprio DOM. Antes deste
// módulo cada rótulo era um literal fixo — a ilha inteira em português, servida
// também a quem lê em inglês ou espanhol.
//
// O dicionário vem do `<script type="application/json" id="seiva-i18n">` que o
// root layout emite (`SeivaWeb.JsTranslations`), então o catálogo Gettext
// continua sendo a fonte única: aqui não se escreve tradução, só se consome.
//
// A chave é o texto em INGLÊS, igual ao `msgid` do catálogo. Sem dicionário
// (payload ausente, JSON quebrado, página fora do layout) `t/2` devolve a
// própria chave — a tela sai em inglês em vez de sair vazia.

let dict = null
let dictionarySource = null

function dictionary() {
  const el = typeof document !== "undefined" ? document.getElementById("seiva-i18n") : null
  const source = el?.textContent || ""
  if (dict && source === dictionarySource) return dict
  dictionarySource = source
  try {
    const parsed = source ? JSON.parse(source) : {}
    dict = parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {}
  } catch (_e) {
    dict = {}
  }
  return dict
}

// Interpola no mesmo formato do Gettext (`%{nome}`), para o msgid ser
// literalmente o mesmo dos dois lados.
function interpolate(text, vars) {
  if (!vars) return text
  return text.replace(/%\{(\w+)\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match
  )
}

/**
 * Traduz `key` para o idioma do leitor.
 *
 * @param {string} key texto em inglês, idêntico ao msgid do catálogo
 * @param {Object} [vars] valores para os marcadores `%{nome}`
 * @returns {string}
 */
export function t(key, vars) {
  const table = dictionary()
  const value = Object.prototype.hasOwnProperty.call(table, key) && typeof table[key] === "string" && table[key] ? table[key] : key
  return interpolate(value, vars)
}

/** Intl locale follows the application language rather than the browser preference. */
export function intlLocale(value = typeof document !== "undefined" ? document.documentElement?.lang : "en") {
  const normalized = String(value || "en").replaceAll("_", "-")
  try {
    const locale = Intl.getCanonicalLocales(normalized)[0]
    return {pt: "pt-BR", en: "en-US"}[locale] || locale
  } catch (_) {
    return "en-US"
  }
}

export default t
